import {init as initUtilsPlv2 } from './plv2';
import {init as initUtilsList } from './list';
import {init as initUtilsSpotlight } from './spotlight';
import {init as initUtilsSparepart } from './sparepart';
import {init as initUtilsEs6 } from './utils-es6';

export const init = () => {
  // Init specific utils
  initUtilsEs6();
  initUtilsPlv2();
  initUtilsList();
  initUtilsSpotlight();
  initUtilsSparepart();
};



// WEBPACK FOOTER //
// ./src/analytics/framework/utils/index.js